import type { CmsImageProps } from '@omnia/ui/src/lib/cms/components/cmsImage/CmsImage'
import { CmsImage } from '@omnia/ui/src/lib/cms/components/cmsImage/CmsImage'
import type { CroppedImage } from '@omnia/ui/src/lib/cms/types/croppedImage'
import type { FC } from 'react'

type ImageDimensions = WidthAndHeightImageDimensions | WidthOnlyImageDimensions | HeightOnlyImageDimensions

interface WidthAndHeightImageDimensions {
    width: number
    height?: number
}

interface WidthOnlyImageDimensions {
    width: number
    height?: number
}

interface HeightOnlyImageDimensions {
    width: number
    height?: number
}

export interface OverrideCmsImageProps {
    dimensions: {
        mobile: ImageDimensions
        tablet: ImageDimensions
        desktop: ImageDimensions
    }
    cmsImageProps: CmsImageProps
    removeCropping?: boolean
}

export const OverrideCmsImage: FC<OverrideCmsImageProps> = props => {
    const cmsImage: CroppedImage = {
        alt: props.cmsImageProps.image?.alt ?? '',
        desktop: getImgSrc('desktop', props),
        tablet: getImgSrc('tablet', props),
        mobile: getImgSrc('mobile', props),
    }

    const cmsImageProps: CmsImageProps = {
        ...props.cmsImageProps,
        image: cmsImage,
    }

    return <CmsImage {...cmsImageProps} />
}

function getImgSrc(imageType: 'desktop' | 'tablet' | 'mobile', props: OverrideCmsImageProps) {
    const imageUrl = props.cmsImageProps.image?.[imageType]
    if (!imageUrl) return ''

    // eslint-disable-next-line no-restricted-properties -- Fine here
    const urlObj = new URL(`${window.location.origin}${imageUrl}`)
    const params = new URLSearchParams(urlObj.search)

    const width = props.dimensions[imageType].width
    const height = props.dimensions[imageType].height

    if (width) {
        params.set('width', width.toString())
    } else {
        params.delete('width')
    }

    if (height) {
        params.set('height', height.toString())
    } else {
        params.delete('height')
    }

    if (props.removeCropping) {
        params.delete('cc')
    }

    urlObj.search = params.toString()
    return urlObj.toString()
}
